import {
  excelColumn,
  excelFile,
  excelSheet,
  excelWorksheet,
  ExcelExportColumn,
  ExcelExportRowMapper,
  ExcelExportSheetConfig,
  ExcelExportWorksheetConfig,
  ExcelImportMeta,
} from "../types";
import {
  GolfExcelHeader,
  GolfExcelSheetName,
  GolfExcelSourceField,
} from "./golfExcel";
import {
  SpaExcelHeader,
  SpaExcelSheetName,
  SpaExcelSourceField,
} from "./spaExcel";
import {
  VersaExcelHeader,
  VersaExcelSheetName,
  VersaExcelSourceField,
} from "./versaExcel";
import {
  RetailItemExcelHeader,
  RetailItemExcelSourceField,
} from "./retailItemExcel";
import { ExcelEmptyDefault } from "../constants/defaults";

type ExcelDefault = string | number | boolean | null;

export const golfExcelColumn = (
  header: GolfExcelHeader,
  sourceField?: GolfExcelSourceField | ExcelEmptyDefault,
  defaultValue?: ExcelDefault,
): ExcelExportColumn => excelColumn(header, sourceField, defaultValue);

export const golfExcelWorksheet = (
  worksheetName: GolfExcelSheetName,
  columns: ExcelExportColumn[],
  templateOnly?: boolean,
  mapRows?: ExcelExportRowMapper,
  importMeta?: ExcelImportMeta,
  includeWhenEmpty?: boolean,
): ExcelExportWorksheetConfig =>
  excelWorksheet(
    worksheetName,
    columns,
    templateOnly,
    mapRows,
    importMeta,
    includeWhenEmpty,
  );

export const golfExcelFile = (
  payloadKey: string,
  fileName: GolfExcelSheetName,
  worksheets: ExcelExportWorksheetConfig[],
): ExcelExportSheetConfig => excelFile(payloadKey, fileName, worksheets);

export const golfExcelSheet = (
  payloadKey: string,
  fileName: GolfExcelSheetName,
  columns: ExcelExportColumn[],
  worksheetName?: GolfExcelSheetName,
  mapRows?: ExcelExportRowMapper,
): ExcelExportSheetConfig =>
  excelSheet(payloadKey, fileName, columns, worksheetName, mapRows);

export const spaExcelColumn = (
  header: SpaExcelHeader,
  sourceField?: SpaExcelSourceField | ExcelEmptyDefault,
  defaultValue?: ExcelDefault,
): ExcelExportColumn => excelColumn(header, sourceField, defaultValue);

export const spaExcelWorksheet = (
  worksheetName: SpaExcelSheetName,
  columns: ExcelExportColumn[],
  templateOnly?: boolean,
  mapRows?: ExcelExportRowMapper,
  importMeta?: ExcelImportMeta,
  includeWhenEmpty?: boolean,
): ExcelExportWorksheetConfig =>
  excelWorksheet(
    worksheetName,
    columns,
    templateOnly,
    mapRows,
    importMeta,
    includeWhenEmpty,
  );

export const spaExcelFile = (
  payloadKey: string,
  fileName: SpaExcelSheetName,
  worksheets: ExcelExportWorksheetConfig[],
): ExcelExportSheetConfig => excelFile(payloadKey, fileName, worksheets);

export const spaExcelSheet = (
  payloadKey: string,
  fileName: SpaExcelSheetName,
  columns: ExcelExportColumn[],
  worksheetName?: SpaExcelSheetName,
  mapRows?: ExcelExportRowMapper,
): ExcelExportSheetConfig =>
  excelSheet(payloadKey, fileName, columns, worksheetName, mapRows);

export const versaExcelColumn = (
  header: VersaExcelHeader,
  sourceField?: VersaExcelSourceField | ExcelEmptyDefault,
  defaultValue?: ExcelDefault,
): ExcelExportColumn => excelColumn(header, sourceField, defaultValue);

export const versaExcelWorksheet = (
  worksheetName: VersaExcelSheetName,
  columns: ExcelExportColumn[],
  templateOnly?: boolean,
  mapRows?: ExcelExportRowMapper,
  importMeta?: ExcelImportMeta,
  includeWhenEmpty?: boolean,
): ExcelExportWorksheetConfig =>
  excelWorksheet(
    worksheetName,
    columns,
    templateOnly,
    mapRows,
    importMeta,
    includeWhenEmpty,
  );

export const versaExcelFile = (
  payloadKey: string,
  fileName: VersaExcelSheetName,
  worksheets: ExcelExportWorksheetConfig[],
): ExcelExportSheetConfig => excelFile(payloadKey, fileName, worksheets);

export const versaExcelSheet = (
  payloadKey: string,
  fileName: VersaExcelSheetName,
  columns: ExcelExportColumn[],
  worksheetName?: VersaExcelSheetName,
  mapRows?: ExcelExportRowMapper,
): ExcelExportSheetConfig =>
  excelSheet(payloadKey, fileName, columns, worksheetName, mapRows);

export const retailItemExcelColumn = (
  header: RetailItemExcelHeader,
  sourceField?: RetailItemExcelSourceField | ExcelEmptyDefault,
  defaultValue?: ExcelDefault,
): ExcelExportColumn => excelColumn(header, sourceField, defaultValue);
